import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(
                $scope,
                $state,
                $uibModal,
                Account,
                Alert,
                CorporateSettingsService,
                DestructiveOperationModal,
                ConfirmModal) {
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.ConfirmModal = ConfirmModal;
    }

    $onInit() {
        this.newSettings = angular.copy(this.settings);
        this.companyId = this.$state.params.companyId;
        this.credentialsInitialized = false;
        
        this.credentials = {key: null, secret: null, ipFilter: this.newSettings.ipFilter};
        this.setIpFilterVar();

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })

        this.href = this.$state.href(
            'company.supported-application-types',
            {protocolstr: 'oauthoidc'}
        );

        if (this.newSettings.accessPolicyId) {
            this.selectedPolicyId = this.newSettings.accessPolicyId;
        } else {
            this.selectedPolicyId = '-1';
        }
    }

    accessPolicyChanged() {
        this.CorporateSettingsService
            .setAdminAccessPolicy(this.companyId, this.selectedPolicyId)
            .then(() => {
                    this.Alert('success', 'global.messages.operation-successful');
                }
            );
    }

    setIpFilterVar(){
        this.ipFilters = this.credentials && this.credentials.ipFilter ? this.credentials.ipFilter.split(";") : null;
    }

    clearNewSettings(){
        this.newSettings = angular.copy(this.settings);
    }

    getCredentials(){
        if (this.settings.hasCredentials) {
            const url = `app/rest/company/${this.companyId}/getCredentials`;
            this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.get_credentials.title',
                textKey: 'corporate.destructive_op.get_credentials.text',
                http: {method: 'GET', url}
            }).then((data) => {
                this.getCredentialsCallback(data);
            });
        }
    }

    getCredentialsCallback(data){
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
    }

    setIpFilterAndOrGenerateCredentialsDestructiveCallback(data,message) {
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
        this.Alert('success', message);
    }

    editCorporateProfile() {
        this.$uibModal
            .open({
                component: 'editCorporateProfile',
                resolve: {settings: () => this.settings},
            }).result
            .then((settings) => this.save(settings));
    }

    editRecoverySettings() {
        this.CorporateSettingsService
            .save(this.companyId, this.settings)
            .then((settings) => {
                    this.settings = settings;
                    this.newSettings = angular.copy(this.settings);
                    this.Alert('success', 'corporate.message.updated');
                }
            );
    }

    editIpAddressFilter() {
        this.$uibModal
            .open({
                component: 'editCorporateIpAddressFilter',
                resolve: {credentials: () => this.credentials},
            }).result
            .then((result) => {
            	 this.credentials = result;
                 this.setIpFilterVar();
                 this.clearNewSettings();
                 this.Alert('success', 'corporate.message.updated');
            });
    }

    generateCredentials() {
        this.$uibModal
            .open({component: 'generateCorporateCredentials'}).result
            .then(() => this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.generate_credentials.title',
                textKey: 'corporate.destructive_op.generate_credentials.text',
                http: {
                    method: 'GET',
                    url: `app/rest/company/${this.companyId}/generateCredentials`,
                }
            }))
            .then((credentials) => {
                this.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials,'corporate.message.credentials_updated');
            });
    }

    save(settings) {
        const numbers = [settings.phoneNumber, settings.phoneNumber2].filter((v) => v);
        [settings.phoneNumber, settings.phoneNumber2] = [...new Set(numbers)];

        this.CorporateSettingsService
            .save(this.companyId, settings)
            .then(() => {
                this.settings = settings;
                this.Alert('success', 'corporate.message.updated');
                this.Account.reload();
            })
    }

    openDynamicClientRegistrationInfoModal() {
        console.log('openDynamicClientRegistrationInfoModal');
    }

    dynamicClientRegistrationSwitchValueChanged(enable) {
        if(enable == this.settings.dynamicClientRegistrationEnabled) {
            return;
        }

        let messageKey = enable ? 'corporate.panel.dynamic_client_registration.enable.confirm' : 'corporate.panel.dynamic_client_registration.disable.confirm';
        this.newSettings.dynamicClientRegistrationEnabled = !enable;
        this.ConfirmModal({
            messageKey: messageKey,
            titleKey: 'sp-confirm.title'
        })
        .then(() => {
                if (enable) {
                    this.enableDynamicClientRegistration();
                } else {
                    this.disableDynamicClientRegistration();
                }
            }
        )
        .finally(() => (this.isSending = false));
    }

    enableDynamicClientRegistration() {
        this.CorporateSettingsService
            .enableDynamicClientRegistration(this.companyId)
            .then((data) => {
                this.settings.dynamicClientRegistrationEnabled = true;
                this.settings.registrationToken = data;
                this.clearNewSettings();
                this.Alert('success', 'corporate.message.updated');
            })
    }

    disableDynamicClientRegistration() {
        this.CorporateSettingsService
            .disableDynamicClientRegistration(this.companyId)
            .then(() => {
                this.settings.dynamicClientRegistrationEnabled = false;
                this.settings.registrationToken = null;
                this.clearNewSettings();
                this.Alert('success', 'corporate.message.updated');
            })
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.controller.js